import {useMapContext} from '@/components/MindMap/index.mjs'
import MenuButton from '../../MenuButton.jsx'

export default function MenuButtonPublishProduct(props) {
    const map = useMapContext()
    const canPublishProduct = map.useCanPublishProduct()

    if (! canPublishProduct) {
        return null
    }

    const onClick = () => map.cmdPushSavePublish()

    const children = '_DES_MAP' === map.data.mapTypeCode ?
        '更新&提交' : '更新&发布制品'

    return (
        <MenuButton
            onClick={onClick}
            {...props}
        >
            {children}
        </MenuButton>
    )
}
